import * as yup from 'yup';
import { DraftAccountDTO } from '../../AccountOpening.meta';
import { ABBREVIATED_STATES_US } from '../../../../CommonConstants';

export const stateToForm = (state: DraftAccountDTO['primaryApplicant']['state']): string | null => {
  const foundState = ABBREVIATED_STATES_US.find(({ value }) => value === state);

  return foundState?.value || null;
};

export const streetAddressLine1Validation = yup
  .string()
  .nullable()
  .required('Address is required');

export const cityValidation = yup
  .string()
  .nullable()
  .required('City is required');

export const stateValidation = yup
  .string()
  .nullable()
  .required('Required');

export const postalCodeValidation = yup
  .string()
  .nullable()
  .required('Required');
